import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { applicationEndpoints } from '../../../../amorg-common/applicationEndpoints';
import { getCookieEmployee } from '../../../../api/serverApiHelpers';

export function PortalLaunchPage(): JSX.Element
{
    const params = useParams<{ siteId: string }>();
    const siteId = params.siteId || '';

    const cookie = getCookieEmployee();
    const target = cookie.status === 'valid'
        ? applicationEndpoints.portal
        : applicationEndpoints.portal_login_siteId.replace(':siteId', siteId);

    return <Navigate to={target} replace />;
}
